module.exports = __webpack_public_path__ + "static/media/header00.2e82e277.jpg";